/**
 * @generated SignedSource<<da125b97559aefbb3ab3df50b4771e41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubInvoiceModelStatusChoices = "CANCELLED" | "DRAFT" | "OVERPAID" | "PAID" | "PENDING" | "REFUND" | "SENT" | "%future added value";
export type PianofunclubLineItemModelItemTypeChoices = "ACCOUNT_OTHER_FEE_OR_DISCOUNT" | "BLOCK_OTHER_FEE_OR_DISCOUNT" | "EXAM_FEE" | "INSTRUMENT_DEPOSIT" | "LESSONS" | "MISSED_LESSON_DISCOUNT" | "%future added value";
export type UpdateLineItemAmountInput = {
  amount: number;
  clientMutationId?: string | null | undefined;
  lineItemId: string;
};
export type UpdateLineItemAmountMutation$variables = {
  input: UpdateLineItemAmountInput;
};
export type UpdateLineItemAmountMutation$data = {
  readonly updateLineItemAmount: {
    readonly accountFeeOrCredit: {
      readonly amount: number | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly invoice: {
      readonly id: string;
      readonly lastModified: string;
      readonly status: PianofunclubInvoiceModelStatusChoices;
      readonly totalAmount: number | null | undefined;
    } | null | undefined;
    readonly lineItem: {
      readonly id: string;
      readonly instrumentDescription: string | null | undefined;
      readonly itemType: PianofunclubLineItemModelItemTypeChoices;
      readonly pupil: {
        readonly id: string;
      } | null | undefined;
      readonly pupilDescription: string | null | undefined;
      readonly pupilDescriptionId: number | null | undefined;
      readonly quantity: number | null | undefined;
      readonly timePeriodDescription: string | null | undefined;
      readonly typeDescription: string | null | undefined;
      readonly unitAmount: number | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type UpdateLineItemAmountMutation = {
  response: UpdateLineItemAmountMutation$data;
  variables: UpdateLineItemAmountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateLineItemAmountPayload",
    "kind": "LinkedField",
    "name": "updateLineItemAmount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LineItemNode",
        "kind": "LinkedField",
        "name": "lineItem",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timePeriodDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pupilDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pupilDescriptionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instrumentDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "typeDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "pupil",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceNode",
        "kind": "LinkedField",
        "name": "invoice",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastModified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountFeeOrCreditNode",
        "kind": "LinkedField",
        "name": "accountFeeOrCredit",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateLineItemAmountMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateLineItemAmountMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b12d617e914bc8f69304b0581d9ab1df",
    "id": null,
    "metadata": {},
    "name": "UpdateLineItemAmountMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateLineItemAmountMutation(\n  $input: UpdateLineItemAmountInput!\n) {\n  updateLineItemAmount(input: $input) {\n    success\n    errors\n    lineItem {\n      id\n      itemType\n      quantity\n      unitAmount\n      timePeriodDescription\n      pupilDescription\n      pupilDescriptionId\n      instrumentDescription\n      typeDescription\n      pupil {\n        id\n      }\n    }\n    invoice {\n      id\n      lastModified\n      totalAmount\n      status\n    }\n    accountFeeOrCredit {\n      id\n      amount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3ed5410f5ce679d039c34006a8be3fa";

export default node;
